"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestPrices = getLatestPrices;
exports.getLatestTokenPricePairs = getLatestTokenPricePairs;
exports.fetchPricesFromAlphaAPI = fetchPricesFromAlphaAPI;
exports.fetchPricesFromCoinGecko = fetchPricesFromCoinGecko;
exports.fetchPriceFromPyth = fetchPriceFromPyth;
exports.fetchPricesFromPyth = fetchPricesFromPyth;
exports.getCachedPairs = getCachedPairs;
exports.getAllCachedPairs = getAllCachedPairs;
exports.getCachedPair = getCachedPair;
exports.cachePrice = cachePrice;
exports.isPriceStale = isPriceStale;
exports.fetchRequiredPrices = fetchRequiredPrices;
const pyth_sui_js_1 = require("@pythnetwork/pyth-sui-js");
const constants_js_1 = require("./constants.js");
const simpleCache_js_1 = require("../protocol/simpleCache.js");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const latestPriceCache = new simpleCache_js_1.SimpleCache(10000);
async function getLatestPrices(pairs, ignoreCache) {
    const pairsToFetch = [];
    const pairsToFetchIndexes = [];
    const prices = pairs.map((pair, index) => {
        const cacheKey = `getLatestPrice-${pair}`;
        if (ignoreCache) {
            latestPriceCache.delete(cacheKey);
        }
        const cachedResponse = latestPriceCache.get(cacheKey);
        if (cachedResponse) {
            return cachedResponse;
        }
        pairsToFetch.push(pair);
        pairsToFetchIndexes.push(index);
        return "";
    });
    if (pairsToFetch.length > 0) {
        try {
            // const fetchedPrices = await fetchPricesFromAlphaAPI(pairsToFetch);
            const allTokenPrices = await fetchRequiredPrices();
            if (pairsToFetch.includes("EGUSDC/USD") &&
                !pairsToFetch.includes("USDC/USD")) {
                pairsToFetch.push("USDC/USD");
                pairsToFetchIndexes.push(pairsToFetch.length + 1);
            }
            if (pairsToFetch.includes("ETHIRD/USD") &&
                !pairsToFetch.includes("USDC/USD")) {
                pairsToFetch.push("USDC/USD");
                pairsToFetchIndexes.push(pairsToFetch.length + 1);
            }
            if (pairsToFetch.includes("EXBTC/USD") &&
                !pairsToFetch.includes("TBTC/USD")) {
                pairsToFetch.push("TBTC/USD");
                pairsToFetchIndexes.push(pairsToFetch.length + 1);
            }
            for (let i = 0; i < pairsToFetch.length; i++) {
                const token = pairsToFetch[i].split("/")[0];
                const price = allTokenPrices[token];
                prices[pairsToFetchIndexes[i]] = price || "0";
            }
            if (pairsToFetch.includes("EGUSDC/USD")) {
                prices[pairsToFetchIndexes[pairsToFetch.indexOf("EGUSDC/USD")]] =
                    allTokenPrices["USDC"] || "0";
            }
            if (pairsToFetch.includes("ETHIRD/USD")) {
                prices[pairsToFetchIndexes[pairsToFetch.indexOf("ETHIRD/USD")]] =
                    allTokenPrices["USDC"] || "0";
            }
            if (pairsToFetch.includes("EXBTC/USD")) {
                prices[pairsToFetchIndexes[pairsToFetch.indexOf("EXBTC/USD")]] =
                    allTokenPrices["TBTC"] || "0";
            }
        }
        catch (error) {
            console.error(`Error in getLatestPrices for pairs ${pairsToFetch}:`, error);
        }
    }
    prices.forEach((price, i) => {
        if (price) {
            const cacheKey = `getLatestPrice-${pairs[i]}`;
            latestPriceCache.set(cacheKey, price);
        }
    });
    return prices;
}
async function getLatestTokenPricePairs(pairs, ignoreCache) {
    const priceMap = {};
    // Use getLatestPrices to fetch all prices at once
    const prices = await getLatestPrices(pairs, ignoreCache);
    pairs.forEach((pair, index) => {
        priceMap[pair] = prices[index];
    });
    return priceMap;
}
async function fetchPricesFromAlphaAPI(pairs) {
    const req_url = `https://api.alphafi.xyz/alpha/fetchPrices?pairs=${pairs.join(",")}`;
    let prices = [];
    try {
        const res = await fetch(req_url);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = (await res.json());
        prices = data;
    }
    catch (error) {
        console.error(`Error fetching prices for pairs ${pairs}:`, error);
        throw error;
    }
    return prices;
}
// ------------------ common code to be used in api and cron -----------
const dynamoDbClient = new client_dynamodb_1.DynamoDBClient({});
const TABLE_NAME = process.env.CACHE_TABLE_NAME;
async function fetchPricesFromCoinGecko(pairs) {
    const coinIds = pairs.map((pair) => constants_js_1.coinGeckoPriceFeed[pair]?.coinId);
    const coinGeckoApiKey = process.env.COIN_GECKO_API_KEY;
    const prices = [];
    if (coinGeckoApiKey) {
        const options = {
            method: "GET",
            headers: {
                accept: "application/json",
                "x-cg-pro-api-key": coinGeckoApiKey,
            },
        };
        try {
            const req_url = `https://pro-api.coingecko.com/api/v3/simple/price?ids=${coinIds.join(",")}&vs_currencies=usd&precision=9`;
            const res = await fetch(req_url, options);
            if (!res.ok) {
                throw new Error(`HTTP error in fetchPricesFromCoinGecko! status: ${res.status}`);
            }
            const resJson = (await res.json());
            coinIds.forEach((coinId) => {
                prices.push(resJson[coinId].usd.toString());
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    console.log("prices", prices);
    return prices;
}
async function fetchPriceFromPyth(pair) {
    const connection = new pyth_sui_js_1.SuiPriceServiceConnection("https://hermes.pyth.network");
    const priceId = constants_js_1.pythPriceFeed[pair]?.priceId;
    if (!priceId) {
        throw new Error(`Price ID not found for pair: ${pair}`);
    }
    try {
        const priceUpdate = await connection.getLatestPriceUpdates([priceId], {
            parsed: true,
        });
        if (priceUpdate && priceUpdate.parsed && priceUpdate.parsed.length >= 1) {
            const priceData = priceUpdate.parsed[0].price;
            const priceValue = parseFloat(priceData.price);
            const exponent = priceData.expo;
            const actualPrice = priceValue * Math.pow(10, exponent);
            return actualPrice.toString();
        }
    }
    catch (error) {
        console.error(`Error fetching price for pair ${pair}:`, error);
    }
    return undefined;
}
async function fetchPricesFromPyth(pairs) {
    const connection = new pyth_sui_js_1.SuiPriceServiceConnection("https://hermes.pyth.network");
    const priceIds = pairs.map((pair) => {
        const priceId = constants_js_1.pythPriceFeed[pair]?.priceId;
        if (!priceId) {
            throw new Error(`Price ID not found for pair: ${pair}`);
        }
        return priceId;
    });
    let prices = [];
    try {
        const priceUpdate = await connection.getLatestPriceUpdates(priceIds, {
            parsed: true,
        });
        if (priceUpdate && priceUpdate.parsed) {
            prices = priceUpdate.parsed.map((parsedPriceFeed) => {
                const priceData = parsedPriceFeed.price;
                const priceValue = parseFloat(priceData.price);
                const exponent = priceData.expo;
                const actualPrice = priceValue * Math.pow(10, exponent);
                return actualPrice.toString();
            });
        }
    }
    catch (error) {
        console.error(`Error fetching price for pairs ${pairs}:`, error);
    }
    return prices;
}
async function getCachedPairs(pairs) {
    const keys = pairs.map((pair) => ({
        pair: { S: pair },
    }));
    const params = {
        RequestItems: {
            [TABLE_NAME]: {
                Keys: keys,
            },
        },
    };
    const result = await dynamoDbClient.send(new client_dynamodb_1.BatchGetItemCommand(params));
    const resultItems = result.Responses?.[TABLE_NAME]
        ? result.Responses[TABLE_NAME]
            .map((item) => ({
            name: item.pair?.S,
            price: item.price?.S,
            lastUpdated: item.lastUpdated?.N
                ? parseInt(item.lastUpdated.N, 10)
                : undefined,
        }))
            .filter((item) => item.name !== undefined &&
            item.price !== undefined &&
            item.lastUpdated !== undefined)
        : [];
    return resultItems;
}
async function getAllCachedPairs() {
    const params = {
        TableName: TABLE_NAME,
    };
    const result = await dynamoDbClient.send(new client_dynamodb_1.ScanCommand(params));
    const resultItems = result.Items
        ? result.Items.map((item) => ({
            name: item.pair?.S,
            price: item.price?.S,
            lastUpdated: item.lastUpdated?.N
                ? parseInt(item.lastUpdated.N, 10)
                : undefined,
        })).filter((item) => item.name !== undefined &&
            item.price !== undefined &&
            item.lastUpdated !== undefined)
        : [];
    return resultItems;
}
async function getCachedPair(pair) {
    const params = {
        TableName: TABLE_NAME,
        Key: {
            pair: { S: pair },
        },
    };
    const result = await dynamoDbClient.send(new client_dynamodb_1.GetItemCommand(params));
    const item = result.Item;
    if (item && item.pair?.S && item.price?.S && item.lastUpdated?.N) {
        return {
            name: item.pair.S,
            price: item.price.S,
            lastUpdated: parseInt(item.lastUpdated.N, 10),
        };
    }
}
async function cachePrice(pair, price) {
    const params = {
        TableName: TABLE_NAME,
        Item: {
            pair: { S: pair },
            price: { S: price },
            lastUpdated: { N: Date.now().toString() },
        },
    };
    await dynamoDbClient.send(new client_dynamodb_1.PutItemCommand(params));
}
function isPriceStale(lastUpdated) {
    const ttl = 60000; // TTL in milliseconds (1 minute)
    return Date.now() > lastUpdated + ttl;
}
// Fetch Prices
// {SUI: "100", USDC: "1.00", USDT: "1.00", ...}
async function fetchRequiredPrices() {
    const apiUrl = "https://api.alphalend.xyz/public/graphql";
    const query = `
      query {
        coinInfo {
          coinType
          coingeckoPrice
        }
      }`;
    const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ query }),
    });
    const dataArr = (await response.json()).data.coinInfo;
    const priceMap = {};
    for (const data of dataArr) {
        let coinType = data.coinType;
        let coin;
        if (coinType.startsWith("0x0")) {
            coinType = "0x" + coinType.substring(3);
        }
        coin = Object.keys(alphafi_sdk_1.coinsList).find((coinKey) => alphafi_sdk_1.coinsList[coinKey].type === coinType);
        if (data.coinType === "0x2::sui::SUI") {
            coin = "SUI";
        }
        if (!coin || coin === "ETHIRD" || coin === "EXBTC") {
            // console.error(`Coin not found for coinType: ${data.coinType}`);
            continue;
        }
        priceMap[coin] = data.coingeckoPrice.toString();
    }
    return priceMap;
}
//# sourceMappingURL=index.js.map